import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

import Breadcrumb from 'components/Common/Breadcrumb2';
import SebelUserTable from './SebelUserTable';
import CreateSebelUser from './CreateSebelUser';

import { getSebelUsers, addSebelUser } from 'store/actions';

const SebelUserList = () => {
    const [isOpen, setIsOpen] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const sebelUsers = useSelector((state) => state.SebelUser.users);
    const loading = useSelector((state) => state.SebelUser.loading);
    const error = useSelector((state) => state.SebelUser.error);

    const permissions = JSON.parse(localStorage?.getItem('permissions'));

    useEffect(() => {
        if (loading) return;
        dispatch(getSebelUsers());
    }, [dispatch]);
     
    const handleSubmit = (data,onClose) => {
        dispatch(addSebelUser(data,onClose));
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <>
            <CreateSebelUser visible={isOpen} onSubmit={handleSubmit} handleClose={handleClose} />
            <div className="page-content container-fluid">
                <div className="d-flex justify-content-between align-items-center mx-3">
                    <Breadcrumb title="Siebel Users" breadcrumbItems={[{ title: "Dashboard", link: `/dashboard` }, { title: "Siebel Users", link: '#' }]} />
                    {permissions?.map(p => p?.permissionName)?.includes("Add Sebel UserId") && (
                        <Button
                            className="bg-primary text-white d-flex justify-content-center gap-1 align-items-center"
                            onClick={() => setIsOpen(true)}
                        >
                            <i className="ti-plus"></i> Add New
                        </Button>
                    )}
                </div>
                <Row className="ms-2">
                    <Col lg={12}>
                        {/* Add filters/search here if needed */}
                    </Col>
                </Row>
                <SebelUserTable loading={loading} List={sebelUsers?.Data} />
            </div>
        </>
    );
};

export default SebelUserList;
